// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class AllBanksInterruptionResponse implements flatbuffers.IUnpackableObject<AllBanksInterruptionResponseT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): AllBanksInterruptionResponse {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsAllBanksInterruptionResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: AllBanksInterruptionResponse,
  ): AllBanksInterruptionResponse {
    return (obj || new AllBanksInterruptionResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsAllBanksInterruptionResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: AllBanksInterruptionResponse,
  ): AllBanksInterruptionResponse {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new AllBanksInterruptionResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  bankName(): string;
  bankName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  bankName(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  liftName(): string;
  liftName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  liftName(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  date(): string;
  date(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  date(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  duration(): string;
  duration(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  duration(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  availability(): string;
  availability(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  availability(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  bankId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  liftId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  static startAllBanksInterruptionResponse(builder: flatbuffers.Builder) {
    builder.startObject(7);
  }

  static addBankName(builder: flatbuffers.Builder, bankNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, bankNameOffset, 0);
  }

  static addLiftName(builder: flatbuffers.Builder, liftNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, liftNameOffset, 0);
  }

  static addDate(builder: flatbuffers.Builder, dateOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, dateOffset, 0);
  }

  static addDuration(builder: flatbuffers.Builder, durationOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, durationOffset, 0);
  }

  static addAvailability(builder: flatbuffers.Builder, availabilityOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, availabilityOffset, 0);
  }

  static addBankId(builder: flatbuffers.Builder, bankId: number) {
    builder.addFieldInt16(5, bankId, 0);
  }

  static addLiftId(builder: flatbuffers.Builder, liftId: number) {
    builder.addFieldInt16(6, liftId, 0);
  }

  static endAllBanksInterruptionResponse(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // bank_name
    builder.requiredField(offset, 6); // lift_name
    builder.requiredField(offset, 8); // date
    builder.requiredField(offset, 10); // duration
    builder.requiredField(offset, 12); // availability
    return offset;
  }

  static createAllBanksInterruptionResponse(
    builder: flatbuffers.Builder,
    bankNameOffset: flatbuffers.Offset,
    liftNameOffset: flatbuffers.Offset,
    dateOffset: flatbuffers.Offset,
    durationOffset: flatbuffers.Offset,
    availabilityOffset: flatbuffers.Offset,
    bankId: number,
    liftId: number,
  ): flatbuffers.Offset {
    AllBanksInterruptionResponse.startAllBanksInterruptionResponse(builder);
    AllBanksInterruptionResponse.addBankName(builder, bankNameOffset);
    AllBanksInterruptionResponse.addLiftName(builder, liftNameOffset);
    AllBanksInterruptionResponse.addDate(builder, dateOffset);
    AllBanksInterruptionResponse.addDuration(builder, durationOffset);
    AllBanksInterruptionResponse.addAvailability(builder, availabilityOffset);
    AllBanksInterruptionResponse.addBankId(builder, bankId);
    AllBanksInterruptionResponse.addLiftId(builder, liftId);
    return AllBanksInterruptionResponse.endAllBanksInterruptionResponse(builder);
  }

  unpack(): AllBanksInterruptionResponseT {
    return new AllBanksInterruptionResponseT(
      this.bankName(),
      this.liftName(),
      this.date(),
      this.duration(),
      this.availability(),
      this.bankId(),
      this.liftId(),
    );
  }

  unpackTo(_o: AllBanksInterruptionResponseT): void {
    _o.bankName = this.bankName();
    _o.liftName = this.liftName();
    _o.date = this.date();
    _o.duration = this.duration();
    _o.availability = this.availability();
    _o.bankId = this.bankId();
    _o.liftId = this.liftId();
  }

  unpackFields(...fields: string[]): AllBanksInterruptionResponseT {
    const t = new AllBanksInterruptionResponseT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("bank_name")) {
      t.bankName = this.bankName();
    }
    if (fieldSet.has("lift_name")) {
      t.liftName = this.liftName();
    }
    if (fieldSet.has("date")) {
      t.date = this.date();
    }
    if (fieldSet.has("duration")) {
      t.duration = this.duration();
    }
    if (fieldSet.has("availability")) {
      t.availability = this.availability();
    }
    if (fieldSet.has("bank_id")) {
      t.bankId = this.bankId();
    }
    if (fieldSet.has("lift_id")) {
      t.liftId = this.liftId();
    }
    return t;
  }
}

export class AllBanksInterruptionResponseT implements flatbuffers.IGeneratedObject {
  constructor(
    public bankName: string | Uint8Array | null = null,
    public liftName: string | Uint8Array | null = null,
    public date: string | Uint8Array | null = null,
    public duration: string | Uint8Array | null = null,
    public availability: string | Uint8Array | null = null,
    public bankId: number = 0,
    public liftId: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.bankName === null || this.bankName === undefined) {
      throw new Error('Required field "bank_name" is not set');
    }
    if (this.liftName === null || this.liftName === undefined) {
      throw new Error('Required field "lift_name" is not set');
    }
    if (this.date === null || this.date === undefined) {
      throw new Error('Required field "date" is not set');
    }
    if (this.duration === null || this.duration === undefined) {
      throw new Error('Required field "duration" is not set');
    }
    if (this.availability === null || this.availability === undefined) {
      throw new Error('Required field "availability" is not set');
    }
    const bankName = this.bankName !== null ? builder.createString(this.bankName!) : 0;
    const liftName = this.liftName !== null ? builder.createString(this.liftName!) : 0;
    const date = this.date !== null ? builder.createString(this.date!) : 0;
    const duration = this.duration !== null ? builder.createString(this.duration!) : 0;
    const availability = this.availability !== null ? builder.createString(this.availability!) : 0;

    return AllBanksInterruptionResponse.createAllBanksInterruptionResponse(
      builder,
      bankName,
      liftName,
      date,
      duration,
      availability,
      this.bankId,
      this.liftId,
    );
  }

  clone(): AllBanksInterruptionResponseT {
    const obj = new AllBanksInterruptionResponseT();
    obj.bankName = this.bankName;
    obj.liftName = this.liftName;
    obj.date = this.date;
    obj.duration = this.duration;
    obj.availability = this.availability;
    obj.bankId = this.bankId;
    obj.liftId = this.liftId;
    return obj;
  }

  equals(other: AllBanksInterruptionResponseT): boolean {
    if (this.bankName !== other.bankName) return false;
    if (this.liftName !== other.liftName) return false;
    if (this.date !== other.date) return false;
    if (this.duration !== other.duration) return false;
    if (this.availability !== other.availability) return false;
    if (this.bankId !== other.bankId) return false;
    if (this.liftId !== other.liftId) return false;
    return true;
  }
}

export function verifyAllBanksInterruptionResponse(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "bank_name");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "lift_name");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "date");
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 10, "duration");
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 12, "availability");
    verifier.checkScalarField(tablePos, 14, 2);
    verifier.checkScalarField(tablePos, 16, 2);
  } finally {
    verifier.popDepth();
  }
}
